import { useState } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import usePartProMessagesListing from "../../../data/usePartProMessagesListings";
import { IPartProConversation } from "../../../models/PartProMessage";
import { IPart } from "../../../models/Part";
import Card from "../Card/Card";
import LoadingWheel from "../LoadingWheel";
import LoadMessagesPrompt from "../LoadMessagesPrompt";
import PartProMessageChain from "../../partProMessaging/PartProMessageChain";
import formatDateTime from "../../../utils/formatDateTime";

export default function PartProPartMessages({ part }: { part: IPart }) {
  const { t } = useTranslation("common");
  const [loadRequested, setLoadRequested] = useState(false);
  const { conversations } = usePartProMessagesListing({ part: part, enabled: loadRequested });
  const [chainOpen, setChainOpen] = useState(false);
  const [chosenConversation, setChosenConversation] = useState<IPartProConversation | undefined>();

  // Cached data from an earlier load is shown straight away
  const showLoadPrompt = !loadRequested && !conversations.data;

  return (
    <Card title={t("PartPro Messages")} bodyClassName={showLoadPrompt ? "px-6 py-3" : "px-6 py-5"}>
      {
        showLoadPrompt ?
          <LoadMessagesPrompt onLoad={() => setLoadRequested(true)} /> :
        conversations.isInitialLoading ?
          <LoadingWheel /> :
          <>
            <PartProMessageChain open={chainOpen} setOpen={setChainOpen} conversation={chosenConversation} />
            <div className="flex-col">
              {
                conversations.data?.data?.length ?
                  conversations.data?.data.map((conversation) => <div key={conversation.id} className="mb-2 hover:bg-slate-200 hover:underline cursor-pointer" onClick={() => { setChosenConversation(conversation); setChainOpen(true); }}>
                    <span className="underline"><span className="font-bold">{conversation.buyerName ?? t("Buyer")}</span> {formatDateTime(conversation.lastMessageAt, DateTime.DATETIME_SHORT)}</span>
                    <p className="">{conversation.lastMessageBody}</p>
                  </div>)
                  :
                  conversations.isError ? <div><p>{t("Unable to retrieve messages")}</p></div> : <div><p>{t("No Messages")}</p></div>
              }
            </div>
          </>
      }
    </Card>
  );
};
